import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Timeffort } from '@/app.context/workspace/persons/sunrises/effort.rmodel';
import TimeffortIcon from './TimeffortIconComponent_Timeline.vue'
import TimeffortText from './TimeffortTextComponent_Timeline.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'ZeroTimeffortComponent_Timeline',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createVNode(TimeffortIcon, { item: _ctx.item }, null, 8, ["item"]),
    _createVNode(TimeffortText, { item: _ctx.item }, null, 8, ["item"])
  ]))
}
}

})